import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { SCP_LOGO } from "../lib/api";

export default function Navbar() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-emerald-900/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-3">
          <img src={SCP_LOGO} alt="Sporting Clube de Portugal crest" className="h-10 w-auto" />
          <div className="leading-tight">
            <div className="font-display font-extrabold text-[#03281B] text-lg tracking-tight">SPORTING CP CAMP</div>
            <div className="text-[10px] uppercase tracking-widest text-[#008057] font-semibold -mt-0.5">San Diego 2027</div>
          </div>
        </Link>
        <div className="hidden md:flex items-center gap-6 text-sm font-semibold text-slate-600">
          <a href="/#overview" className="hover:text-[#008057] transition-colors">Overview</a>
          <a href="/#pricing" className="hover:text-[#008057] transition-colors">Pricing</a>
          <a href="/#services" className="hover:text-[#008057] transition-colors">Services</a>
          <a href="/status" className="hover:text-[#008057] transition-colors">My Registration</a>
          <Link to="/sponsor" className="text-[#B8860B] font-bold hover:text-[#008057] transition-colors">Sponsor</Link>
          <Link to="/admin" data-testid="admin-login-button" className="text-slate-400 hover:text-[#008057] transition-colors">Admin</Link>
        </div>
        <button
          data-testid="nav-register-cta"
          onClick={() => navigate("/register")}
          className="rounded-full bg-[#008057] hover:bg-[#054D34] text-white px-5 py-2 text-sm font-bold transition-colors shadow-lg shadow-emerald-900/10"
        >
          Register Now
        </button>
      </div>
    </header>
  );
}
